import React from "react";
import { Ticket } from "lucide-react";

/**
 * Small pill rendered on event cards / detail when the event was synced from
 * the founder's ticketing platform (allsale.events). Ticket purchases happen
 * there — we just deep-link.
 *
 * Props:
 *   source     — event.source from the shared backend ("allsale.events" when synced)
 *   priceLabel — event.price_label ("From $10", "Free", etc.)
 *   variant    — "chip" (small pill on cards) | "banner" (wider strip on detail)
 */
export default function EventSourceChip({ source, priceLabel, variant = "chip" }) {
  const isTicketed = source === "allsale.events";
  if (!isTicketed && !priceLabel) return null;

  if (variant === "banner") {
    return (
      <div
        data-testid="event-source-banner"
        className="inline-flex items-center gap-2 rounded-full bg-slate-900/5 border border-soft px-3 py-1.5 text-xs font-semibold text-slate-600"
      >
        <Ticket className="w-3.5 h-3.5 text-[color:var(--brand-orange)]" />
        {isTicketed ? "Ticketed via Allsale Events" : "Ticketed"}
        {priceLabel && <span className="text-slate-400">·</span>}
        {priceLabel && <span className="text-slate-900">{priceLabel}</span>}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="event-source-chip-wrap">
      {priceLabel && (
        <span
          data-testid="event-price-label"
          className="inline-flex items-center rounded-full bg-[color:var(--brand-orange)] text-white text-[10px] font-bold px-2 py-0.5"
        >
          {priceLabel}
        </span>
      )}
      {isTicketed && (
        <span
          data-testid="event-source-chip"
          className="inline-flex items-center gap-1 rounded-full bg-white/95 backdrop-blur-sm border border-white/60 text-slate-700 text-[10px] font-semibold px-2 py-0.5 shadow-sm"
          title="Ticketed via Allsale Events"
        >
          <Ticket className="w-3 h-3" /> Allsale Events
        </span>
      )}
    </div>
  );
}
